import { useEffect, useState, useCallback, useRef } from "react";
import { getPaginatedResearchQueryRunScoringConfigs } from "../services/scoringService";

interface IuseFetchPaginatedResearchQueryRunScoringConfigs {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: any;
  pSize: any;
  runInstanceId?: number | null;
  genericResearchQueryId?: number | null;
  isActive?: boolean;
}

const useFetchPaginatedResearchQueryRunScoringConfigs = ({
  setIsLoading,
  page,
  pSize,
  runInstanceId,
  genericResearchQueryId,
  isActive,
}: IuseFetchPaginatedResearchQueryRunScoringConfigs) => {
  const [data, setData] = useState<any>([]);
  const abortControllerRef = useRef<AbortController | null>(null);

  const fetchData = useCallback(async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    setIsLoading(true);
    try {
      const result = await getPaginatedResearchQueryRunScoringConfigs({
        page,
        pSize,
        runInstanceId,
        genericResearchQueryId,
        isActive,
      });
      setData(result);
    } catch (err: any) {
      if (err.name !== "AbortError") {
        setData([]);
      }
    } finally {
      setIsLoading(false);
    }
  }, [page, pSize, runInstanceId, genericResearchQueryId, isActive, setIsLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return [data, fetchData];
};

export default useFetchPaginatedResearchQueryRunScoringConfigs;
